export type CompanyDraft = {
  companyName: string;
  website: string;
  employeeCountBand: string;
  companyType: string;
  countryCode: string;
  contactName: string;
  contactEmail: string;
  contactPhone: string;
  intendedUse: string;
};

export type OnboardingSession = {
  id: string;
};

export type OnboardingClient = {
  createSession(draft: CompanyDraft): Promise<OnboardingSession>;
};

async function readError(response: Response): Promise<string> {
  try {
    const body = (await response.json()) as { message?: string; error?: string };
    return body.message?.trim() || body.error?.trim() || `Request failed (${response.status})`;
  } catch {
    return `Request failed (${response.status})`;
  }
}

export const onboardingClient: OnboardingClient = {
  async createSession(draft) {
    const response = await fetch('/api/v1/onboarding/sessions', {
      method: 'POST',
      credentials: 'include',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        intent: 'create_company',
        applicationDraft: {
          companyName: draft.companyName.trim(),
          website: draft.website.trim() || null,
          employeeCountBand: draft.employeeCountBand,
          companyType: draft.companyType,
          countryCode: draft.countryCode,
          contactName: draft.contactName.trim(),
          contactEmail: draft.contactEmail.trim(),
          contactPhone: draft.contactPhone.trim() || null,
          intendedUse: draft.intendedUse.trim() || null,
        },
        metadata: { source: 'app-connectplane' },
      }),
    });

    if (!response.ok) {
      throw new Error(await readError(response));
    }

    const session = (await response.json()) as Partial<OnboardingSession>;
    if (!session.id?.trim()) {
      throw new Error('Onboarding did not return a session. Please try again.');
    }
    return { id: session.id };
  },
};

export function portalStartUrl(sessionId: string): string {
  const portalBase = (import.meta.env.VITE_PORTAL_START_URL || 'https://myaccount.connectplane.com/start').trim();
  const url = new URL(portalBase, window.location.origin);
  url.searchParams.set('onboarding_session', sessionId);
  return url.toString();
}
